export default function Plaque(props) {
  const { x, y, size, text, base_size, scale, onClick } = { ...props };
  const display_text = text;
  const style = {
    alignContent: "center",
    textAlign: "center",
    verticalAlign: "center",
    zIndex: 1.0,
  };
  const textstyle = {
    color: "white",
    fontFamily:
      '"Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue", Helvetica, Arial, sans-serif',
  };
  const color_blue = "#003b9f";
  const color_green = "#7cb561";

  switch (size) {
    case "large":
      {
        const half_dim = (0.5 * 12 * base_size) / Math.SQRT2;
        style.width = 2 * half_dim + "px";
        style.height = 2 * half_dim + "px";
        style.backgroundColor = color_blue;
        textstyle.fontSize = 0.45 * base_size + "pt";

        style.clipPath = `polygon(0px ${half_dim}px, ${half_dim}px 0, 
            ${2 * half_dim}px ${half_dim}px, ${half_dim}px ${2 * half_dim}px)`;
      }
      break;
    case "medium":
      {
        const half_dim = (0.5 * 6 * base_size) / Math.SQRT2;

        style.width = (6 * base_size) / Math.SQRT2 + "px";
        style.height = (6 * base_size) / Math.SQRT2 + "px";
        style.backgroundColor = color_green;
        textstyle.fontSize = 0.25 * base_size + "pt";

        style.clipPath = `polygon(0px ${half_dim}px, ${half_dim}px 0px, 
        ${2 * half_dim}px ${half_dim}px, ${half_dim}px ${2 * half_dim}px)`;
      }
      break;

    case "small-up":
      {
        const half_dim = (0.5 * 6 * base_size) / Math.SQRT2;

        style.width = (6 * base_size) / Math.SQRT2 + "px";
        style.height = (3 * base_size) / Math.SQRT2 + "px";
        style.backgroundColor = color_blue;
        style.clipPath = `polygon(0px ${half_dim}px, ${half_dim}px 0px, 
        ${2 * half_dim}px ${half_dim}px)`;
        textstyle.fontSize = base_size / 5 + "pt";
        textstyle.paddingTop = base_size / 1.5 + "px";
      }
      break;
    case "small-down":
      {
        const half_dim = (0.5 * 6 * base_size) / Math.SQRT2;

        style.width = (6 * base_size) / Math.SQRT2 + "px";
        style.height = (3 * base_size) / Math.SQRT2 + "px";
        style.backgroundColor = color_blue;
        style.clipPath = `polygon(0px 0px, ${2 * half_dim}px 0px,  
        ${half_dim}px ${half_dim}px 
        )`;
        textstyle.fontSize = base_size / 5 + "pt";
        textstyle.marginTop = -base_size / 1.25 + "px";
      }
      break;
  }

  return (
    <>
      <div
        style={{
          display: scale == 1 ? "none" : "block",
          backgroundColor: "rgba(40,40,40,0.5)",
          width: "100vw",
          height: "100vh",
          position: "absolute",
          zIndex: 3,
        }}
      ></div>
      <div
        style={{
          display: "block",
          position: "relative",
          top: y,
          left: x,
          width: 0,
          height: 0,
          overflow: "visible",
          zIndex: scale == 1 ? 1 : 4,
        }}
      >
        <div
          onClick={(e) => onClick(e)}
          style={{
            ...style,
            background: "lightgrey",
            transform: `scale(${scale})`,
            transformOrigin: "center center",
          }}
        >
          <div
            style={{
              ...style,
              transform: "scale(0.95)",
              transformOrigin: "center center",
            }}
          >
            <div style={textstyle}>{display_text}</div>
          </div>
        </div>
      </div>
    </>
  );
}
